import React, { useState } from "react";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Divider from "@mui/material/Divider";
import LogoutIcon from "@mui/icons-material/Logout";
import TokenIcon from "@mui/icons-material/Token";
import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import DevicesIcon from "@mui/icons-material/Devices";
import TaskIcon from "@mui/icons-material/Task";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import BuildIcon from "@mui/icons-material/Build";
import LanguageIcon from "@mui/icons-material/Language";
import SettingsIcon from "@mui/icons-material/Settings";
import TableViewIcon from "@mui/icons-material/TableView";
import ManageHistoryIcon from "@mui/icons-material/ManageHistory";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";
import PersonIcon from "@mui/icons-material/Person";
import DrawIcon from "@mui/icons-material/Draw";
import PaidIcon from "@mui/icons-material/Paid";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { AuthAPI } from "../../../apis/api-index";
import { clearUser } from "../../../store/slice/user-slice";
import {
  HasUserRoles,
  IsLoggedInUserContractAuthManager,
  IsLoggedInUserSuperAdmin,
  IsLoggedInUserPricingApprover,
} from "../../../hoc/withAuthRedirect";
import { Tooltip } from "@mui/material";

export default function MainNavBar({ handleDrawer }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const menuItems = [
    {
      text: t("navigationMenu.approval"),
      icon: <TaskIcon />,
      link: "/quotelist",
    },
    {
      text: t("navigationMenu.quoteApprovalReassignment"),
      icon: <EditCalendarIcon />,
      link: "/quoteapprovalreassignmentlist",
    },
    IsLoggedInUserSuperAdmin() && {
      text: t("navigationMenu.userRoles"),
      icon: <PersonIcon />,
      link: "/userrolelist",
    },
    IsLoggedInUserContractAuthManager() && {
      text: t("navigationMenu.authorisedSignConfig"),
      icon: <DrawIcon />,
      link: "/authsignconfiglist",
    },
    HasUserRoles() && {
      text: t("navigationMenu.consumableProduct"),
      icon: <TokenIcon />,
      link: "/consumableproductlist",
    },
    HasUserRoles() && {
      text: t("navigationMenu.pezode"),
      icon: <SpaceDashboardIcon />,
      link: "/pezodelist",
    },
    HasUserRoles() && {
      text: t("createDevice.device"),
      icon: <DevicesIcon />,
      link: "/devicelist",
      subItems: [
        {
          text: t("createDevice.deviceType"),
          link: "/devicetypelist",
        },
        {
          text: t("navigationMenu.itineraryTimes"),
          link: "/itinerarytimeslist",
        },
      ],
    },
    HasUserRoles() && {
      text: t("navigationMenu.grossBranch"),
      icon: <AccountTreeIcon />,
      link: "/grossbranchlist",
      subItems: [
        {
          text: t("navigationMenu.marketSector"),
          link: "/marketsectorlist",
        },
        {
          text: t("navigationMenu.branchCostConfig"),
          link: "/branchcostconfiglist",
        },
        {
          text: t("navigationMenu.serviceType"),
          link: "/servicetypelist",
        },
      ],
    },
    HasUserRoles() && {
      text: t("navigationMenu.zone"),
      icon: <LanguageIcon />,
      link: "/zonelist",
    },
    HasUserRoles() && {
      text: t("navigationMenu.pricingSettings"),
      icon: <SettingsIcon />,
      link: "/pricingsettingslist",
    },
    HasUserRoles() && {
      text: t("navigationMenu.pricingConfiguration"),
      icon: <BuildIcon />,
      link: "/pricingconfiguration",
    },
    HasUserRoles() && {
      text: t("navigationMenu.approvalMatrix"),
      icon: <TableViewIcon />,
      subItems: [
        {
          text: t("navigationMenu.gmSales"),
          link: "/gmsales",
        },
        {
          text: t("navigationMenu.gmPercentile"),
          link: "/gmpercentile",
        },
      ],
    },
    HasUserRoles() && {
      text: t("navigationMenu.auditInfo"),
      icon: <ManageHistoryIcon />,
      link: "/auditinfo",
    },
    (IsLoggedInUserPricingApprover() || HasUserRoles()) && {
      text: t("navigationMenu.pricingChanges"),
      icon: <PaidIcon />,
      link: "/pricingchanges",
    },
    {
      text: t("navigationMenu.logout"),
      icon: <LogoutIcon />,
      link: "/",
    },
  ].filter(Boolean);

  const [openItems, setOpenItems] = useState({});
  const dispatch = useDispatch();
  const handleSignOut = async () => {
    try {
      await AuthAPI.logOut();
      dispatch(clearUser());
      navigate("/");
    } catch (err) {
      alert(err);
    }
  };

  const handleClick = (index) => {
    setOpenItems((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };
  function handleTextClick(item) {
    if (item.link) {
      if (item.link === "/") {
        handleSignOut();
      } else {
        navigate(item.link);
      }
      handleDrawer();
    }
    // if (routeGuardContext.getFormState()) {
    //   publishEvent(APP_CUSTOM_EVENTS.COMPONENT_UNLOAD, {
    //     callback: () => {
    //       if (item.link) {
    //         if (item.link === "/") {
    //           handleSignOut();
    //         } else {
    //           navigate(item.link);
    //         }
    //         handleDrawer();
    //       }
    //     },
    //   });
    // } else {
    //   if (item.link) {
    //     if (item.link === "/") {
    //       handleSignOut();
    //     } else {
    //       navigate(item.link);
    //     }
    //     handleDrawer();
    //   }
    // }
  }

  return (
    <List sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper", overflowX: "hidden", scrollbarWidth: "thin" }}>
      {menuItems.map((item, index) => (
        <React.Fragment key={index}>
          <ListItemButton sx={{ display: "flex", alignItems: "center" }}>
            <Tooltip title={item.text}>
              <ListItemIcon onClick={() => handleTextClick(item)}>{item.icon}</ListItemIcon>
            </Tooltip>
            <div
              onClick={() => handleTextClick(item)}
              style={{ flex: "1", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
            >
              <ListItemText primary={item.text} primaryTypographyProps={{ style: { whiteSpace: 'normal', overflow: "hidden", textOverflow: 'ellipsis', lineHeight: '1.2em', display: '-webkit-box', WebkitLineClamp: '2', WebkitBoxOrient: 'vertical' } }} />
            </div>
            {item.subItems && (
              <div onClick={() => handleClick(index)}>{openItems[index] ? <ExpandLessIcon /> : <ExpandMoreIcon />}</div>
            )}
          </ListItemButton>
          {item.subItems && (
            <Collapse in={openItems[index]} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {item.subItems.map((subItem, subIndex) => (
                  <ListItemButton key={subIndex} sx={{ pl: 4 }}>
                    <ListItemIcon></ListItemIcon>
                    <div onClick={() => handleTextClick(subItem)}>
                      <ListItemText primary={subItem.text} />
                    </div>
                  </ListItemButton>
                ))}
              </List>
            </Collapse>
          )}
          {index < menuItems.length - 1 && <Divider />}
        </React.Fragment>
      ))}
    </List>
  );
}
